export * from './enums/database.generated'

export const MarketMakerQuoteKpiMetricEnum = {
  LoanValueDepth50Bps: 'loan_value_depth_50_bps',
  LoanValueDepth100Bps: 'loan_value_depth_100_bps',
  LoanValueDepth200Bps: 'loan_value_depth_200_bps',
  BidAskSpreadBps: 'bid_ask_spread_bps',
} as const

export type MarketMakerQuoteKpiMetricEnumType =
  (typeof MarketMakerQuoteKpiMetricEnum)[keyof typeof MarketMakerQuoteKpiMetricEnum]

export const MarketMakerQuoteKpiMetricEnumValues = [
  'loan_value_depth_50_bps',
  'loan_value_depth_100_bps',
  'loan_value_depth_200_bps',
  'bid_ask_spread_bps',
] as const

export const MarketMakerQuoteKpiMinMaxUnitEnum = {
  Percent: 'percent',
  Usd: 'usd',
} as const

export enum MimeType {
  FOLDER = 'application/vnd.google-apps.folder',
  SHORTCUT = 'application/vnd.google-apps.shortcut',
  CSV = 'text/csv',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export const RFQKPISummaryFilterOptionEnum = {
  AllReceivedQuotes: 'all_received_quotes',
  AllSelectedAverage: 'all_selected_average',
  MyQuotesAverage: 'my_quotes_average',
} as const

export const RFQKPISummaryFilterOptionEnumValues = [
  'all_received_quotes',
  'all_selected_average',
  'my_quotes_average',
] as const

export type RFQKPISummaryFilterOptionEnumType =
  (typeof RFQKPISummaryFilterOptionEnum)[keyof typeof RFQKPISummaryFilterOptionEnum]

export const ActiveRFQStatusFilterOptionEnum = {
  All: 'all',
  AcceptingQuotes: 'accepting_quotes',
  InReviewRFQs: 'in_review_rfqs',
  ParticipatingRFQs: 'participating_rfqs',
  IgnoredRFQs: 'ignored_rfqs',
} as const

export const ActiveRFQStatusFilterOptionEnumValues = [
  'all',
  'accepting_quotes',
  'in_review_rfqs',
  'participating_rfqs',
  'ignored_rfqs',
] as const

export type ActiveRFQStatusFilterOptionEnumType =
  (typeof ActiveRFQStatusFilterOptionEnum)[keyof typeof ActiveRFQStatusFilterOptionEnum]

export const ClosedRFQStatusFilterOptionEnum = {
  All: 'all',
  ParticipatedAndSelected: 'participated_and_selected',
  ParticipatedAndRejected: 'participated_and_rejected',
  IgnoredRFQs: 'ignored',
} as const

export const ClosedRFQStatusFilterOptionEnumValues = [
  'all',
  'participated_and_selected',
  'participated_and_rejected',
  'ignored',
] as const

export type ClosedRFQStatusFilterOptionEnumType =
  (typeof ClosedRFQStatusFilterOptionEnum)[keyof typeof ClosedRFQStatusFilterOptionEnum]

export const MMPerformanceStatusEnum = {
  Selected: 'selected',
  NotSelected: 'not_selected',
  Ignored: 'ignored',
} as const

export const MMPerformanceStatusEnumValues = ['selected', 'not_selected', 'ignored'] as const

export type MMPerformanceStatusEnumType = (typeof MMPerformanceStatusEnum)[keyof typeof MMPerformanceStatusEnum]

export const MmLinkRequestStatusEnum = {
  None: 'none',
  Pending: 'pending',
  Approved: 'approved',
  Declined: 'declined',
} as const

export const MmLinkRequestStatusValues = ['none', 'pending', 'approved', 'declined'] as const

export type MmLinkRequestStatusEnumType = (typeof MmLinkRequestStatusEnum)[keyof typeof MmLinkRequestStatusEnum]

export const MmLinkNotificationChannelEnum = {
  Email: 'email',
  Telegram: 'telegram',
} as const

export const MmLinkNotificationChannelValues = ['email', 'telegram'] as const

export type MmLinkNotificationChannelEnumType =
  (typeof MmLinkNotificationChannelEnum)[keyof typeof MmLinkNotificationChannelEnum]

export interface MmLinkNotificationRecipient {
  marketMakerId: string
  channels: MmLinkNotificationChannelEnumType[]
}

export const LiquidityTypeOptionEnum = {
  Ask: 'ask',
  Bid: 'bid',
  BidAsk: 'bidAsk',
} as const

export const LiquidityTypeOptionEnumValues = ['ask', 'bid', 'bidAsk'] as const

export type LiquidityTypeOptionEnumType = (typeof LiquidityTypeOptionEnum)[keyof typeof LiquidityTypeOptionEnum]

export const DepthLevelOptionEnum = {
  Depth50: '50',
  Depth100: '100',
  Depth200: '200',
} as const

export const DepthLevelOptionEnumValues = ['50', '100', '200'] as const

export type DepthLevelOptionEnumType = (typeof DepthLevelOptionEnum)[keyof typeof DepthLevelOptionEnum]

export const RankValueOptionEnum = {
  Dollar: 'value_dollar',
  Percent: 'value_percent',
} as const

export const RankValueOptionEnumValues = ['value_dollar', 'value_percent'] as const

export type RankValueOptionEnumType = (typeof RankValueOptionEnum)[keyof typeof RankValueOptionEnum]

export const RankPresentationOptionEnum = {
  Rank: 'rank',
  Values: 'values',
} as const

export const RankPresentationOptionEnumValues = ['rank', 'values'] as const

export type RankPresentationOptionEnumType =
  (typeof RankPresentationOptionEnum)[keyof typeof RankPresentationOptionEnum]

export const LikertScaleEnum = {
  StronglyDisagree: 1,
  Disagree: 2,
  Neutral: 3,
  Agree: 4,
  StronglyAgree: 5,
} as const

export type LikertScaleEnumType = (typeof LikertScaleEnum)[keyof typeof LikertScaleEnum]

export const NotificationTypeEnum = {
  RfqCreated: 'rfq_created',
  RfqCanceled: 'rfq_canceled',
  RfqApproved: 'rfq_approved',
  QuoteSubmitted: 'quote_submitted',
  QuoteCanceled: 'quote_canceled',
  QuoteEdited: 'quote_edited',
  RfqCompetitionUpdate: 'rfq_competition_update',
  RfqCompetitionUpdate1H: 'rfq_competition_update_1h',
  RfqTimeRemaining24H: 'rfq_time_remaining_24h',
  RfqTimeRemaining1H: 'rfq_time_remaining_1h',
  RfqRound1QuotesAcceptedSelectedMarketMaker: 'rfq_round_1_quotes_accepted_selected_market_maker',
  RfqRound1QuotesAcceptedOtherMarketMaker: 'rfq_round_1_quotes_accepted_other_market_maker',
  RfqRound1QuotesRequotedSelectedMarketMaker: 'rfq_round_1_quotes_requoted_selected_market_maker',
  RfqRound1QuotesRequotedOtherMarketMaker: 'rfq_round_1_quotes_requoted_other_market_maker',
  RfqRound2QuotesAcceptedSelectedMarketMaker: 'rfq_round_2_quotes_accepted_selected_market_maker',
  RfqRound2QuotesAcceptedOtherMarketMaker: 'rfq_round_2_quotes_accepted_other_market_maker',
  MissingDataDrops: 'missing_data_drops',
  ContactSent: 'contact_sent',
  ApiKeyExpiring: 'api_key_expiring',
  ApiKeyExpired: 'api_key_expired',
  ApiKeyDeleted: 'api_key_deleted',
} as const

export type NotificationTypeEnumType = (typeof NotificationTypeEnum)[keyof typeof NotificationTypeEnum]

export const NotificationTypeEnumValues = [
  'rfq_created',
  'rfq_canceled',
  'rfq_approved',
  'quote_submitted',
  'quote_canceled',
  'quote_edited',
  'rfq_competition_update',
  'rfq_competition_update_1h',
  'rfq_time_remaining_24h',
  'rfq_time_remaining_1h',
  'rfq_round_1_quotes_accepted_selected_market_maker',
  'rfq_round_1_quotes_accepted_other_market_maker',
  'rfq_round_1_quotes_requoted_selected_market_maker',
  'rfq_round_1_quotes_requoted_other_market_maker',
  'rfq_round_2_quotes_accepted_selected_market_maker',
  'rfq_round_2_quotes_accepted_other_market_maker',
  'missing_data_drops',
  'contact_sent',
  'api_key_expiring',
  'api_key_expired',
  'api_key_deleted',
] as const

export const ReportStatusFilterOptionEnum = {
  Submitted: 'submitted',
  Missing: 'missing',
} as const

export const ReportStatusFilterOptionEnumValues = ['submitted', 'missing'] as const

export type ReportStatusFilterOptionEnumType =
  (typeof ReportStatusFilterOptionEnum)[keyof typeof ReportStatusFilterOptionEnum]

export const ReportStatusEnum = {
  Success: 'success',
  Invalid: 'invalid',
  Missing: 'missing',
  OverReported: 'over-reported',
} as const

export const ReportStatusEnumValues = ['success', 'invalid', 'missing', 'over-reported'] as const

export type ReportStatusEnumType = (typeof ReportStatusEnum)[keyof typeof ReportStatusEnum]

export const LpStrategyKpiEnum = {
  Low: 'low',
  Moderate: 'moderate',
  High: 'high',
} as const

export const LpStrategyKpiEnumValues = ['low', 'moderate', 'high'] as const

export type LpStrategyKpiEnumType = (typeof LpStrategyKpiEnum)[keyof typeof LpStrategyKpiEnum]

export const MMRFQTranchePriceFlagEnum = {
  Discount: 'discount',
  Par: 'par',
  Premium: 'premium',
} as const

export const MMRFQTranchePriceFlagEnumValues = ['discount', 'par', 'premium'] as const

export type MMRFQTranchePriceFlagEnumType = (typeof MMRFQTranchePriceFlagEnum)[keyof typeof MMRFQTranchePriceFlagEnum]

export const ExchangeSkewEnum = {
  Cex: 'CEX',
  Dex: 'DEX',
  Even: 'EVEN',
} as const

export const ExchangeSkewEnumValues = ['CEX', 'DEX', 'EVEN'] as const

export type ExchangeSkewEnumType = (typeof ExchangeSkewEnum)[keyof typeof ExchangeSkewEnum]

export const TimeframeEnum = {
  '24h': '24h',
  '7d': '7d',
  '30d': '30d',
  '60d': '60d',
  '90d': '90d',
  '180d': '180d',
  '365d': '365d',
  all: 'all',
  latest: 'latest',
} as const

export const TimeframeEnumValues = ['24h', '7d', '30d', '60d', '90d', '180d', '365d', 'all', 'latest'] as const

export type TimeframeEnumType = (typeof TimeframeEnum)[keyof typeof TimeframeEnum]

export const FdvAtTgePreferenceEnum = {
  NoPreference: 'no_preference',
  Lt50m: 'lt_50m',
  From50mTo100m: '50m_100m',
  From100mTo250m: '100m_250m',
  From250mTo500m: '250m_500m',
  From500mTo1b: '500m_1b',
  Gt1b: 'gt_1b',
} as const

export const FdvAtTgePreferenceEnumValues = [
  'no_preference',
  'lt_50m',
  '50m_100m',
  '100m_250m',
  '250m_500m',
  '500m_1b',
  'gt_1b',
] as const

export type FdvAtTgePreferenceEnumType = (typeof FdvAtTgePreferenceEnum)[keyof typeof FdvAtTgePreferenceEnum]

export const ExchangeGroupingFilterEnum = {
  Individual: 'individual',
  Forgd: 'forgd',
  TierAgg: 'tieragg',
} as const

export const ExchangeGroupingFilterEnumValues = ['individual', 'forgd', 'tieragg'] as const

export type ExchangeGroupingFilterEnumType =
  (typeof ExchangeGroupingFilterEnum)[keyof typeof ExchangeGroupingFilterEnum]

export const ExchangeTierGroupEnum = {
  Tier1: 'tier1',
  Tier2: 'tier2',
  Tier3: 'tier3',
} as const

export const ExchangeTierGroupEnumValues = ['tier1', 'tier2', 'tier3'] as const

export type ExchangeTierGroupEnumType = (typeof ExchangeTierGroupEnum)[keyof typeof ExchangeTierGroupEnum]

export const FloatBucketEnum = {
  GreaterThan50: 'gt_50',
  From25To50: '25_50',
  From10To25: '10_25',
  LessThan10: 'lt_10',
} as const

export const FloatBucketEnumValues = ['gt_50', '25_50', '10_25', 'lt_10'] as const

export type FloatBucketEnumType = (typeof FloatBucketEnum)[keyof typeof FloatBucketEnum]

export const FloatBucketTimeframeEnum = {
  '1h': '1h',
  '1d': '1d',
  '7d': '7d',
  '1m': '1m',
  '3m': '3m',
  '6m': '6m',
  '12m': '12m',
} as const

export const FloatBucketTimeframeEnumValues = ['1h', '1d', '7d', '1m', '3m', '6m', '12m'] as const

export type FloatBucketTimeframeEnumType = (typeof FloatBucketTimeframeEnum)[keyof typeof FloatBucketTimeframeEnum]

export const ExchangePerformanceTimeframeEnum = {
  Tge: 'tge',
  OneDay: '1d',
  OneWeek: '1w',
  OneMonth: '1m',
  TwoMonths: '2m',
  ThreeMonths: '3m',
  AllTime: 'all_time',
} as const

export const ExchangePerformanceTimeframeEnumValues = ['tge', '1d', '1w', '1m', '2m', '3m', 'all_time'] as const

export type ExchangePerformanceTimeframeEnumType =
  (typeof ExchangePerformanceTimeframeEnum)[keyof typeof ExchangePerformanceTimeframeEnum]
